import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Verification.module.css';

const Verification = () => {
    return (
        <div className={styles.container}>
            <header>
                <h2>Enter 6 digit verification code sent on your given number</h2>
                <div className={styles.status}>
                    <p>0:23 min</p>
                    <p><strong>resend</strong></p>
                </div>
            </header>

            <main>
                <div className={styles.field}>
                    <label>Enter OTP</label>
                    <input type="text" name="otp" placeholder="Enter 6 digit verification code" />
                </div>
                <Link to="/contact-us"><button>Submit</button></Link>
            </main>
        </div>
    )
}

export default Verification
